import {
  addQueryParam,
  removeQueryParam,
} from '../../../../store/redux/slices/form.slice';
import SectionWrapper from '../SectionWrapper';
import { Box, Link, Text } from '@chakra-ui/react';
import { useAppSelector } from '../../../../store/redux/hooks';
import { useAppDispatch } from '../../../../store/redux/hooks';
import CustomQueryParameter from './CustomQueryParameter';
import AddMoreButton from '../AddMoreButton';
import { QueryParamState } from '../../../../store/types/form';
import { useEffect, useMemo } from 'react';

const CustomQueryParameters = () => {
  const queryParams = useAppSelector((state) => state.form.queryParams);
  const formEnabled = useAppSelector((state) => state.form.enabled);
  const templateFields = useAppSelector((state) => state.template.fields);
  const dispatch = useAppDispatch();

  const availableFieldIds = useMemo(
    () =>
      new Set(
        Object.values(templateFields).flatMap((section) =>
          (Object.values(section ?? {}) as Array<{ id?: string } | null>)
            .filter((field) => field != null && field.id)
            .map((field) => (field as { id: string }).id)
        )
      ),
    [templateFields]
  );

  const availableFieldCount = availableFieldIds.size;
  const limitReached = queryParams.length >= availableFieldCount;

  useEffect(() => {
    queryParams.forEach((q) => {
      if (q.id && !availableFieldIds.has(q.id)) {
        dispatch(removeQueryParam(q._clientId));
      }
    });
  }, [availableFieldIds, queryParams, dispatch]);

  return (
    <SectionWrapper
      title="Custom query parameters"
      openOnLoad={true}
      id="custom-query-parameters-section"
      tooltip="Adding custom query parameters allows you to pass in additional data to your form which can be used to populate the pass."
      subtitle={
        <Text>
          See our{' '}
          <Link
            color="linkBlue"
            href="https://docs.passentry.com/documentation/guides/custom-download-forms/guide#custom-query-parameters"
            target="_blank"
          >
            guide
          </Link>{' '}
          for more information.
        </Text>
      }
    >
      {queryParams.map((queryParam: QueryParamState, index: number) => (
        <CustomQueryParameter
          key={queryParam._clientId}
          _clientId={queryParam._clientId}
          index={index}
          id={queryParam.id}
          name={queryParam.name}
          required={queryParam.required}
          isDisabled={!formEnabled}
        />
      ))}
      {!limitReached && (
        <Box mt={4}>
          <AddMoreButton
            onClick={() => {
              dispatch(addQueryParam());
            }}
            text={`Connect ${queryParams.length > 0 ? 'another field' : 'a field'}`}
            isDisabled={!formEnabled}
          />
        </Box>
      )}
    </SectionWrapper>
  );
};

export default CustomQueryParameters;
